import type { LinkStylesProps } from '~/styles/link';
import styled from 'styled-components';
import { UnstyledButton } from '@workramp/ui';
import { linkStyles } from '~/styles/link';

export const MediaObjectWrapper = styled.div`
  overflow-wrap: break-word; // Forces long, unbroken names to wrap
`;

export const AvatarButton = styled(UnstyledButton)`
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: none;
`;

export const NameLink = styled(UnstyledButton)<LinkStylesProps>`
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: none;
  width: 100%;
  text-align: left;

  ${linkStyles}
`;
